import type { Dispatch, SetStateAction } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useFileActions } from '@/hooks/useFileActions';
import type { FileResultResponse } from '../types/api.types';
import { AnalysisTabs } from '../types/common.types';

interface UseShortcutsProps {
  resultData?: FileResultResponse;
  setHideDetectionCanvas: Dispatch<SetStateAction<boolean>>;
  setPageIndex: Dispatch<SetStateAction<number>>;
  numPages: number;
  pageIndex: number;
  handleRotate: (rotation: number) => void;
  toggle: AnalysisTabs;
}

const useShortcuts = ({
  resultData,
  setHideDetectionCanvas,
  setPageIndex,
  numPages,
  pageIndex,
  handleRotate,
  toggle,
}: UseShortcutsProps) => {
  const { toggleFavorite } = useFileActions();

  useHotkeys('enter', () => {
    if (toggle === 'preview' && resultData?.id && resultData?.favori)
      toggleFavorite(resultData?.id, resultData?.favori);
  });

  useHotkeys('space', () => {
    if (toggle === 'preview') setHideDetectionCanvas((prevValue) => !prevValue);
  });

  useHotkeys('r', () => {
    handleRotate(90);
  });

  useHotkeys('l', () => {
    handleRotate(-90);
  });

  useHotkeys('right', () => {
    if (pageIndex < numPages - 1) setPageIndex((prevIndex) => prevIndex + 1);
  });

  useHotkeys('left', () => {
    if (pageIndex > 0) setPageIndex((prevIndex) => prevIndex - 1);
  });
};

export default useShortcuts;
